var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 22,
    height: 16,
    rx: 2,
    fill: "#4D4E67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1C2 0.447715 2.44772 0 3 0H19C19.5523 0 20 0.447715 20 1V2H2V1Z",
    fill: "#4D4E67"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.5,
    width: 7,
    height: 7,
    rx: 1.5,
    fill: "#4D4E67",
    stroke: "#E8F0F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 1,
    fill: "#E8F0F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.e867e9f8.svg";
export { ForwardRef as ReactComponent };